import { render } from "./RundeckVersionDisplay.vue?vue&type=template&id=1aae4bfc&scoped=true&ts=true"
import script from "./RundeckVersionDisplay.vue?vue&type=script&lang=ts"
export * from "./RundeckVersionDisplay.vue?vue&type=script&lang=ts"

import "./RundeckVersionDisplay.vue?vue&type=style&index=0&id=1aae4bfc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aae4bfc"]])

export default __exports__